export default __webpack_public_path__ + "static/media/cfx-cm-report.d4ba7594.svg";